import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const SearchQueryArrowContainer = styled.div<{ opacity: number }>`
  display: flex;
  left: 0;
  justify-content: center;
  position: absolute;
  opacity: ${(props) => props.opacity};
  overflow: hidden;
  top: ${Screen.widthRatio * 290}px;
  transform: scale(0.4);
  width: 100%;
`;

export default SearchQueryArrowContainer;
